// extracted by mini-css-extract-plugin
module.exports = {"title":"clinical-portal-3__IncompleteConsultationMessage__title","message":"clinical-portal-3__IncompleteConsultationMessage__message"};